
export enum EQuoteOrderableField {
  Name = "Name",
  Customer = "Customer",
  Assessor = "Assessor",
  Status = "Status",
  Date = "Date"
}
